import React from 'react'
import PropTypes from 'prop-types'
import { Message } from '@paypalcorp/worldready-react'
import { Button, RefreshIcon } from '@paypalcorp/pp-react'
import { connect } from 'react-redux'
import { getRetryContentId, getActionName } from 'utils/content'
import * as fpti from 'utils/fpti'
import IconPage from 'components/common/IconPage'
import COMMON_FPTI_TAGS from '@/constants/fpti-tags/common'
import { serverData } from 'utils/server-data'

let flowName = '@flow'
let fptiPage = `@flow:retry`
const fptiRetryBtn = 'retryBtn'
const { retryActivityTags, tryAgainClickTags } = COMMON_FPTI_TAGS as any

class Retry extends React.Component<any, any> {
  static propTypes = {
    onRetry: PropTypes.func,
    actionType: PropTypes.string,
    legalProductName: PropTypes.string,
    flowInstanceId: PropTypes.string,
    fptiEntryPoint: PropTypes.string,
    errorType: PropTypes.string,
    errorMessage: PropTypes.string,
  }

  UNSAFE_componentWillMount() {
    flowName = getActionName(this.props.actionType)
    fptiPage = fptiPage.replace('@flow', flowName)
    fpti.startCPLTracking(fptiPage)
  }

  componentDidMount() {
    const { flowInstanceId, fptiEntryPoint, errorType, errorMessage } = this.props
    const { page, ...rest } = retryActivityTags(flowName)
    fpti.logActivity(page, rest)
    fpti.recordImpression(fptiPage, {
      flowInstanceId,
      fptiEntryPoint,
      errorType,
      errorMessage,
    })
    fpti.endCPLTracking()
  }

  handleOnRetry = () => {
    fpti.recordClick(fptiPage, fptiRetryBtn, tryAgainClickTags)
    this.props.onRetry()
  }

  render() {
    const { actionType, legalProductName: legalProductNameProp } = this.props
    
    // Derive legalProductName from serverData if not provided or empty
    const country = serverData.locality?.country
    // eslint-disable-next-line i18n-scan/no-country-dependency
    const legalProductName = legalProductNameProp || (country === 'GB' ? 'card' : 'product')
    
    return (
      <IconPage
        data-testid="retry-page"
        icon={<RefreshIcon size="xl" color="sysColorPrimaryMain" />}
        headerId={getRetryContentId('header', actionType)}
        contentId={getRetryContentId('content', actionType)}
        contentProps={{ legalProductName }}
        wrapWithModalContent
      >
        <Button data-testid="retry-button" onClick={this.handleOnRetry}>
          <Message id="error.button.tryAgain" />
        </Button>
      </IconPage>
    )
  }
}

const stateProps = (state, ownProps) => {
  const { fetchRetry } = ownProps.fetchingState ? ownProps.fetchingState : state.card || {}

  const { actionType, retryHandler } = fetchRetry || {}
  return { onRetry: retryHandler, actionType }
}

export default connect(stateProps)(Retry)
